import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-hashtag"></i>
            <span>热门话题</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            糖心视频社区热门讨论话题，看看大家都在聊什么甜蜜内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href={item.url}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600 transition-all cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}